import React from "react";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { Confirmation } from "../../../../../Shared/Process/Process/Confirmation";
import { IStepConfig, StepType } from "../../../../../Shared/Process/Process/Process";
import {
    IWizardComponentStateGeneric,
    WizardComponentGeneric,
} from "../../../../../Shared/Process/WizardComponentGeneric";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { Contents } from "../../../../Resoures/Contents";
import { Urls } from "../../../../Urls";
import { AddLogoAction } from "../Action/AddLogoAction";
import { steppers } from "../Resource/Content";
import { AddLogo } from "./AddLogo";
import { UserStore } from "../../../../../Dashboard/Stroes/Variable";

interface IAddLogoWizardState extends IWizardComponentStateGeneric {
    imageBlobData?: { primary: string; secondary: string };
    validationErrors?: string[];
    errorMessage: any[];
}

export class AddLogoWizard extends WizardComponentGeneric<IAddLogoWizardState> {
    constructor(props: any) {
        super(props);
    }

    initState() {
        this.state = { data: {}, isLoading: false, active: true, errorMessage: [] } as IAddLogoWizardState;
    }

    onSubmit() {}

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        const isAdmin = UserStore.getUserInfo()?.IsAdmin != null ? UserStore.getUserInfo().IsAdmin : true;
        if (to == -1) {
            this.onExit();
        } else {
            AddLogoAction.uploadLogo(this.state.imageBlobData, () => {
                setTimeout(() => {
                    AddLogoAction.getLogo(isAdmin);
                    Navigator.navigateTo(Urls.get().AddLogoConfirmation);
                }, 3000);
            });
        }
    }

    onCancel() {
        this.onExit();
    }

    onExit() {
        Navigator.navigateTo(Urls.get().main.Settings);
    }

    setStepperConfig() {
        const stepConfig: IStepConfig[] = [];
        stepConfig.push({
            title: steppers.addLogo,
            url: Urls.get().AddLogo,
            path: Contents.URLMap.uploadLogo,
            onStepLeave: (from, to) => this.onStepperLeave(from, to),
            component: (
                <AddLogo
                    {...this.getStepProps(0)}
                    imageBlobData={this.state.imageBlobData}
                    onChange={(url) => this.onImageUrlChange(url)}
                    data={null}
                />
            ),
        });
        stepConfig.push({
            title: steppers.confirmation,
            url: Urls.get().AddLogoConfirmation,
            path: Contents.URLMap.confirmation,
            onStepLeave: (from, to) => this.onExit(),
            type: StepType.Confirmation,
            component: (
                <Confirmation
                    onExit={() => this.onExit()}
                    successMessage={"Logo successfully uploaded"}
                    isLoading={false}
                    buttonLabel={"Back to settings"}
                />
            ),
        });

        this.stepperConfig = stepConfig;
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.onSave = null;
        processProps.processTitle = "Add logo";
        processProps.active = true;
        return processProps;
    }

    private onImageUrlChange(imageUrl: { primary: string; secondary: string }) {
        this.setState({ imageBlobData: imageUrl, errorMessage: [], isShowErrorMsg: false });
    }

    render() {
        if (!checkPermission(UserClaim.AdviserPortalAddFirmLogoCanView)) {return null;}
        return super.render();
    }
}
